function Loader() {
  return (
    <div className="loader">
      <div className="ddd">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      </div>  
    </div>
  );
}

export default Loader;
